import { useTranslation } from 'react-i18next'

import { Typography, TypographyVariant } from 'src/components/atoms'

export const EmptyState = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div className="py-16 text-center">
      <Typography
        variant={TypographyVariant.bodyXl}
        className="text-content-secondary"
      >
        {t('whyWeInvest.emptyState')}
      </Typography>
    </div>
  )
}
